import "./CardSections.css";
import { useState, useEffect } from "react";

const X2ABBIrb1600 = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  const textOnCard = (
    <div className="text-in-card">
      <h3>Що входить в систему:</h3>
      <hr />
      <ul>
        <li>
          1) 2× роботи-маніпулятори ABB IRB 1600 з контролером IRC5, система
          MultiMove
        </li>
        <li>2) 2× позиціонери (обертачі, 2 осі), синхронізовані з роботами</li>
        <li>
          3) 2× зварювальні апарати Fronius TPS 4000 + роботизована подача
          зварювального дроту
        </li>
        <li>4) 2× роботизовані рукави з рідинною системою охолодження</li>
        <li>5) Навчання оператора/персоналу</li>
      </ul>
      <p className="weight-text">Ціна системи: 62 000 євро</p>
    </div>
  );
  return (
    <div className="card-blok">
      <h2>2× ABB IRB 1600 + IRC5 MultiMove</h2>
      <div className="card">
        <div className="card-img">
          <img
            src={require("../../../STATIC/images/OrangeRobots/TwoOrangeRobots.webp")}
            alt="Robot"
          />
        </div>
        <div className="card-video-text">
          <iframe
            src="https://www.youtube.com/embed/fHZI1CzQqt0"
            title="ABB Robotics - New Generation Workpiece Positioners"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          {windowWidth > 900 ? textOnCard : ""}
        </div>
        {windowWidth <= 900 ? textOnCard : ""}
      </div>
    </div>
  );
};

export default X2ABBIrb1600;
